const checkoutV3Prefix = 'CheckoutV3';

const CHECKOUT_V3 = Object.freeze({
  DELIVERY: {
    COMPLETING_ORDER_ERROR_DELIVERY: `${checkoutV3Prefix} Completing Order Error Delivery`,
  },
  PAYMENT: {
    COMPLETING_ORDER_ERROR_PAYMENT: `${checkoutV3Prefix} Completing Order Error Payment`,
    COMPLETING_ORDER_ERROR_GENERAL: `${checkoutV3Prefix} Completing Order Error General`,
  },
});

const PRODUCT_PAGE_PREFIX = 'ProductPage';

const PRODUCT_PAGE = Object.freeze({
  CTA_SUBNAV: {
    CLICK_PRIMARY: `${PRODUCT_PAGE_PREFIX} CTA Subnav Click Primary`,
    CLICK_LINK: `${PRODUCT_PAGE_PREFIX} CTA Subnav Click Link`,
  },
  // GRW-816: PDP add-to-cart click instrumentation. Emitted as the standard
  // public-web `click_link` event, which is already in the app-marketing
  // allowlist (production_public_web_clicks_solidshop_source) that feeds
  // app_mktg_web.attribution.public_web_clicks. A custom EVENTNAME would
  // dead-end in the raw CDP layer without a paired allowlist PR, so `click_link`
  // ships without cross-team coordination. Nav vs body is parsed off
  // link_parent_id. Approach confirmed with the app-marketing pipeline owner.
  ADD_TO_CART_CLICK: {
    EVENT_NAME: 'click_link',
    LINK_TEXT: 'Add to cart',
    LINK_PARENT_ID_BODY: 'shop-pdp-body',
    LINK_PARENT_ID_NAV: 'shop-pdp-nav',
  },
});

const SAAS_ON_SHOP_PREFIX = 'SaasOnShop';

const SAAS_ON_SHOP = Object.freeze({
  BUNDLE_OFFERED: `${SAAS_ON_SHOP_PREFIX}:BundleOffered`,
  BUNDLE_PLAN_ADDED: `${SAAS_ON_SHOP_PREFIX}:BundlePlanAdded`,
  BUNDLE_PLAN_REMOVED: `${SAAS_ON_SHOP_PREFIX}:BundlePlanRemoved`,
  BUNDLE_COMPARE_PLANS_OPENED: `${SAAS_ON_SHOP_PREFIX}:BundleComparePlansOpened`,
  BUNDLE_PLAN_SELECTED: `${SAAS_ON_SHOP_PREFIX}:BundlePlanSelected`,
  BUNDLE_MIGRATION_INELIGIBLE_RESOLVED: `${SAAS_ON_SHOP_PREFIX}:BundleMigrationIneligibleResolved`,
  BUNDLE_UPGRADE_OFFERED: `${SAAS_ON_SHOP_PREFIX}:BundleUpgradeOffered`,
});

const CDP_EVENT_NAMES = {
  CHECKOUT_V3,
  PRODUCT_PAGE,
  SAAS_ON_SHOP,
};

export default CDP_EVENT_NAMES;
